import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Landing.module.scss';

interface LandingProps {}

const Landing: FC<LandingProps> = () => (
  <div className={styles.Landing} data-testid="Landing">
    <NavLink to="/ford-fulkerson">Ford-Fulkerson</NavLink>
    <NavLink to="/edmonds-karp">Edmonds-Karp</NavLink>
    <NavLink to="/dinic">Dinic</NavLink>
    <NavLink to="/goldberg-tarjan">Goldberg Tarjan</NavLink>
    <NavLink to="/tests">Tests</NavLink>
  </div>
);

export default Landing;
